module.exports = __webpack_public_path__ + "static/media/Apple_Badge.057587ae.svg";